import StickySidebarPresenter from "../components/sticky-sidebar/presenter/sticky-sidebar.js";

const contentElement = document.querySelector(`.category-sidebar,.articles-sidebar`);
const stickySidebarComponent = new StickySidebarPresenter(contentElement, {
  minWidth: 840,
  bottomSpacing: 20
});
stickySidebarComponent.init();
